import PurchaseMethodModule from './PurchaseMethodModule';
export default PurchaseMethodModule;
